import {Observable} from 'rxjs';
import {CpmCJobsSpecificationApiModel} from '../../models/c-global/cpmc-jobs-specification.api-model';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCJobsSpecificationSetActiveApiSchema} from '../../schemas/c-global/cpmc-jobs-specification.api-schemas';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetJobsSpecificationListParams = {
    [K in keyof CpmCJobsSpecificationApiModel]?: CpmCJobsSpecificationApiModel[K] extends AllowedQueryParamTypes
        ? CpmCJobsSpecificationApiModel[K]
        : never;
} & {} & QueryParams;

/**
 * JobsSpecification Api Service
 */
export class CpmCJobsSpecificationApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'created_at', order: -1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/jobs-specification';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCJobsSpecificationApiService.baseUrl()}/list`;
    }
    public static endpointGet(jobsSpecificationUUID: string): string {
        return `${CpmCJobsSpecificationApiService.baseUrl()}/${jobsSpecificationUUID}`;
    }
    public static endpointGetExecutorActiveSpecification(jobType: string): string {
        return `${CpmCJobsSpecificationApiService.baseUrl()}/${jobType}/executor/active`;
    }
    public static endpointUpdateExecutorActiveSpecification(jobType: string): string {
        return `${CpmCJobsSpecificationApiService.baseUrl()}/${jobType}/executor/active`;
    }

    // ===============================================================
    // ===============================================================

    public static getJobsSpecificationList(
        params: CpmCGetJobsSpecificationListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCJobsSpecificationApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCJobsSpecificationApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCJobsSpecificationApiModel>>(
            CpmCJobsSpecificationApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getJobsSpecificationByUUID(jobsSpecificationUUID: string): Observable<CpmCJobsSpecificationApiModel> {
        return CpmCApiBridge.httpGet<CpmCJobsSpecificationApiModel>(
            CpmCJobsSpecificationApiService.endpointGet(jobsSpecificationUUID)
        );
    }
    public static getExecutorActiveSpecification(jobType: string): Observable<CpmCJobsSpecificationApiModel> {
        return CpmCApiBridge.httpGet<CpmCJobsSpecificationApiModel>(
            CpmCJobsSpecificationApiService.endpointUpdateExecutorActiveSpecification(jobType),
            {}
        );
    }
    public static updateExecutorActiveSpecification(
        jobType: string,
        payload: CpmCJobsSpecificationSetActiveApiSchema
    ): Observable<null> {
        return CpmCApiBridge.httpPut<null>(
            CpmCJobsSpecificationApiService.endpointUpdateExecutorActiveSpecification(jobType),
            payload
        );
    }
}
